import { Component } from '@angular/core';
import { TopBarComponent } from '../top-bar/top-bar.component';
import { RouterOutlet } from '@angular/router';
import {
  TUI_SANITIZER,
  TuiAlertModule,
  TuiDialogModule,
  TuiRootModule,
} from '@taiga-ui/core';
import { SideBarComponent } from '../side-bar/side-bar.component';
import { NgDompurifyModule } from '@tinkoff/ng-dompurify';
import { FooterComponent } from '../footer/footer.component';
@Component({
  selector: 'app-main-content',
  standalone: true,
  imports: [
    TopBarComponent,
    RouterOutlet,
    TuiRootModule,
    TuiDialogModule,
    TuiAlertModule,
    SideBarComponent,
    FooterComponent,
  ],
  templateUrl: './main-content.component.html',
  styleUrl: './main-content.component.scss',
  providers: [{ provide: TUI_SANITIZER, useClass: NgDompurifyModule }],
})
export class MainContentComponent {}
